import { render } from "./FoldersTable.vue?vue&type=template&id=a59385f6&scoped=true"
import script from "./FoldersTable.vue?vue&type=script&lang=js"
export * from "./FoldersTable.vue?vue&type=script&lang=js"

import "./FoldersTable.vue?vue&type=style&index=0&id=a59385f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59385f6"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd});
